import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import AddNewProduct from "./index";
import API_KEY from "api";

export default function EditProduct() {
  const params = useParams();
  const [formData, setFormData] = useState(null);
  const [categoryData, setCategoryData] = useState(null);

  function fieldSorter(fields) {
    return function (a, b) {
        return fields
            .map(function (o) {
                var dir = 1;
                if (o[0] === '-') {
                   dir = -1;
                   o=o.substring(1);
                }
                if (a[o] > b[o]) return dir;
                if (a[o] < b[o]) return -(dir);
                return 0;
            })
            .reduce(function firstNonZeroValue (p,n) {
                return p ? p : n;
            }, 0);
    };
}
  const getCategoryData = (id) => {
    API_KEY.URL.get(`${API_KEY.path.attributes}`, {
      params: {
        fields: "*,attributes.attributes_id.*",
      },
    })
      .then((res) => {
        var tab_keys  = {"production":0, "internal":1, "vendor":2, "exclusive":3, "production_detail":4}
        var attributes = res?.data?.data.map(function(e){
          e.sorter = tab_keys[e.tabname];
          e.priority = e.priority;
         // console.log(e.sorter)
          return e;
        });
        attributes.sort(fieldSorter(["sorter","-priority"]))
        res.data.data.attributes = attributes
        setCategoryData(res?.data?.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    // API_KEY.URL.get(API_KEY.path.products, {
    //   params: {
    //     "filter[id][_eq]": params?.id,
    //     fields:
    //       "*,variants.*,variants.attributes.attribute_values_id.*,variants.attributes.attribute_values_id.attribute_id.*,product_images.directus_files_id,attributes.attribute_values_id.*,attributes.attribute_values_id.attribute_id.*,secondary_category.name,secondary_category.id",
    //   },
    // })
      
    API_KEY.URL.get(
          `https://staging.sourcerer.tech/items/products/${params?.id}`,{
            params: {
             
              fields:
                "*,variants.*,variants.attributes.attribute_values_id.*,variants.attributes.attribute_values_id.attribute_id.*,product_images.directus_files_id,attributes.attribute_values_id.*,attributes.attribute_values_id.attribute_id.*,secondary_category.name,secondary_category.id",
            },
          }
        ).then((res) => {
        if (res.data?.data) {
          const formData = res.data?.data;
          getCategoryData(formData?.secondary_category?.id);
          setFormData(formData);
        }
      })
      .catch((error) => console.log(error));
  }, [params]);

  if (categoryData) {

    return (
      <div>
        <AddNewProduct
          page={"edit"}
          formData={formData}
          initalCategoryData={categoryData}
        />
      </div>
    );
  }

  return <div></div>;
}
